<template>
  <div>
    <NotFound v-if="show404" return-path-name="find-symptoms" />
    <div v-else>
      <div class="container" v-if="isLoading">
        <div class="row">
          <div class="d-flex justify-content-center">
            <Loading />
          </div>
        </div>
      </div>
      <div class="repair" v-else>
        <div class="container">
          <div class="row">
            <h5>Wycena</h5>
            <h1 class="intro-text">
              <strong>{{ price.name }}</strong>
            </h1>
          </div>
        </div>
        <div
          class="container mt-3"
          v-if="Object.keys(this.$route.query).length > 0"
        >
          <div
            class="d-flex justify-content-between border-gray"
            @click="refreshVariants"
          >
            <span>Wariant:</span>
            <router-link
              :to="{
                name: 'tec-estimate-detail',
                params: {
                  typeId: this.$route.params.typeId,
                  korId: this.$route.params.korId,
                  itemMpId: this.$route.params.itemMpId,
                },
              }"
            >
              <span
                class="d-flex justify-content-center align-items-center change-variant"
                >zmień wariant
                <refreshing-arrows-icon class="ms-2" />
              </span>
            </router-link>
          </div>
          <div class="row pt-2 ps-4 pe-4">
            <ul>
              <li
                v-for="versionType in price.versions.filter(
                  (vt) => this.$route.query[vt.id] !== undefined
                )"
                :key="versionType.id"
              >
                <div class="variant-li">
                  <span>{{ versionType.name }} - <br /></span>
                  <span class="bold">{{
                    selectedVersionName(versionType)
                  }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="container mt-3"
          v-if="
            price.versions &&
            price.versions.length !== Object.keys(this.$route.query).length
          "
        >
          <span class="bold">Ta wycena ma kilka wariantów - wybierz swój:</span>
          <div v-for="versionType in price.versions" :key="versionType.id">
            <div
              v-if="this.$route.query[versionType.id] === undefined"
              class="mt-2"
            >
              <span class="variant-name">{{ versionType.name }}</span>
              <select
                class="form-select"
                :name="versionType.id"
                v-model="selectedParams[versionType.id]"
              >
                <option disabled selected hidden :value="undefined">
                  Wybierz
                </option>
                <option
                  v-for="version in versionType.versions"
                  :key="version.id"
                  :value="version.id"
                >
                  {{ version.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="d-flex justify-content-center align-items-center mt-4">
            <button
              class="btn button-gradient select-variant"
              @click="selectVariantOption"
            >
              Zatwierdź wybór
            </button>
          </div>
        </div>
        <div class="container mt-4" v-if="isUpdatingVariant">
          <div class="row">
            <div class="d-flex justify-content-center">
              <Loading />
            </div>
          </div>
        </div>
        <div v-else>
          <single-cost
            v-if="price"
            :work-min="price.workMin"
            :work-max="price.workMax"
            :part-min="price.partMin"
            :part-max="price.partMax"
            :estimated-max="price.estimatedMax"
            :estimated-min="price.estimatedMin"
            :contain-parts="price.containParts"
            :has-prices="price.hasPrices"
            :used-parts="price.usedParts"
          />
        </div>
        <foot-notes />
        <div class="container">
          <div class="row">
            <div class="col-12">
              <mail-to-us
                bold-text="Masz inną wycenę?"
                small-text="Prześlij nam informację lub kosztorys do weryfikacji"
                :type="FormTypes.ESTIMATE"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import NotFound from "@/views/NotFound";
import Loading from "@/components/Loading";
import SingleCost from "@/components/repair-detail-components/SingleCost";
import MailToUs from "@/improvementForms/MailToUs";
import FootNotes from "@/components/repair-detail-components/FootNotes";
import RefreshingArrowsIcon from "@/components/icons/RefreshingArrowsIcon";
import { mapGetters } from "vuex";
import { FormTypes } from "@/improvementForms/formTypes";

export default {
  mounted() {
    this.selectedParams = { ...this.$route.query };
    this.fetchRepair();
  },
  data: function () {
    return {
      price: null,
      workName: "",
      show404: false,
      isLoading: false,
      isUpdatingVariant: false,
      selectedParams: {},
      FormTypes,
    };
  },
  methods: {
    fetchRepair() {
      if (this.isLoading || this.isUpdatingVariant) return;
      this.isLoading = true;
      axios
        .get(
          `/api/tec/work/${this.$route.params.typeId}/${this.$route.params.korId}/${this.$route.params.itemMpId}/${this.$route.params.workId}/`,
          { params: this.$router.params }
        )
        .then((response) => {
          if (response.data.prices.length < 1) {
            this.show404 = true;
          } else {
            this.price = response.data.prices[0];
          }
          document.title = this.price.name;
          this.isLoading = false;
        })
        .catch((reason) => {
          if (reason.response.status === 404) {
            this.show404 = true;
            this.isLoading = false;
          } else {
            console.error(reason);
          }
        });
    },
    updatePrices() {
      if (this.isLoading || this.isUpdatingVariant) return;
      this.isUpdatingVariant = true;
      axios
        .get(
          `/api/tec/work/${this.$route.params.typeId}/${this.$route.params.korId}/${this.$route.params.itemMpId}/${this.$route.params.workId}/`,
          { params: this.$router.params }
        )
        .then((response) => {
          if (response.data.prices.length < 1) {
            this.show404 = true;
          } else {
            this.price = response.data.prices[0];
          }
          this.isUpdatingVariant = false;
        })
        .catch((reason) => {
          if (reason.response.status === 404) {
            this.show404 = true;
            this.isUpdatingVariant = false;
          } else {
            console.error(reason);
          }
        });
    },
    selectVariantOption() {
      if (this.isUpdatingVariant) return;
      this.updatePrices();
      this.$router.push({ query: this.selectedParams });
    },
    selectedVersionName(versionType) {
      return versionType.versions.find(
        (v) => v.id == this.$route.query[versionType.id]
      )?.name;
    },
    refreshVariants() {
      if (this.isUpdatingVariant) return;
      this.selectedParams = {};
      this.updatePrices();
      this.$router.push({ query: {} });
    },
  },
  computed: {
    ...mapGetters("cars", ["getSelectedCar"]),
  },
  watch: {
    "$route.params.korId": {
      handler: function () {
        this.fetchRepair();
      },
      deep: true,
      immediate: true,
    },
    getSelectedCar() {
      if (!this.getSelectedCar) {
        this.$router.push({ name: "index" });
      } else if (
        this.getSelectedCar &&
        this.$route.params.typeId !== this.getSelectedCar?.typeId.toString()
      ) {
        this.$router.push({
          name: "tec-estimate-list",
          params: { typeId: this.getSelectedCar.typeId },
        });
      }
    },
    "$route.params.itemMpId": {
      handler: function () {
        this.fetchRepair();
      },
      deep: true,
      immediate: true,
    },
    "$route.params.workId": {
      handler: function () {
        this.fetchRepair();
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    RefreshingArrowsIcon,
    FootNotes,
    MailToUs,
    Loading,
    NotFound,
    SingleCost,
  },
};
</script>
<style scoped>
h5 {
  font-family: Comfortaa-light, serif;
  color: gray;
}

h1,
h6 {
  font-family: Roboto, sans-serif;
}

.button-gradient {
  padding: 10px;
  color: white;
  background: var(--brand-gradient);
  border-radius: 5px;
}

.bold {
  font-weight: bold;
}

.variant-name {
  font-weight: 400;
  font-size: 16px;
}

.select-variant {
  font-family: "Comfortaa-light", serif;
  font-size: 18px;
}

.change-variant {
  color: var(--brand-color);
  cursor: pointer;
}

.border-gray {
  border-bottom: 1px gray solid;
  padding-bottom: 8px;
}

.variant-li {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 10px;
}
</style>
